function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { FieldArray, Formik } from 'formik';
import flowFP from 'lodash/fp/flow';
import keyByFP from 'lodash/fp/keyBy';
import orderByFP from 'lodash/fp/orderBy';
import pullAllWithFP from 'lodash/fp/pullAllWith';
import setFP from 'lodash/fp/set';
import identity from 'lodash/identity';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import map from 'lodash/map';
import React from 'react';
import { array, boolean, object } from 'yup';
import text from '../../../text';
import { getNowDate } from '../../../utilities/date';
import { isDetailedStatusCompleted, isDetailedStatusInProgress } from '../../../utilities/job';
import { productDetailedStatusSchema } from '../../../validation/job';
import Button from '../../button/Button';
import Checkbox from '../Checkbox';
import UpdateProductTable from './UpdateProductTable';
var updateFormSchema = function(compareFn) {
    return object().shape({
        detailedStatus: array().of(productDetailedStatusSchema).test('has-changed', 'no changes', /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(value) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                compareFn(value)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }()),
        sendNotification: boolean().notRequired()
    });
};
var setCompletedDate = function(item) {
    return isDetailedStatusCompleted(item.status) ? setFP('completedAt', getNowDate(), item) : identity(item);
};
var setStartedDate = function(item) {
    return isDetailedStatusInProgress(item.status) && !item.startedAt ? setFP('startedAt', getNowDate(), item) : identity(item);
};
var setCreatedDate = function(detailedStatus) {
    return setFP('createdAt', getNowDate(), detailedStatus);
};
var formatValues = function(initial, detailedStatus) {
    return flowFP([
        pullAllWithFP(isEqual, initial),
        function(result) {
            return map(result, function(item) {
                return flowFP([
                    setCompletedDate,
                    setStartedDate,
                    setCreatedDate
                ])(item);
            });
        },
        keyByFP('productKey')
    ])(detailedStatus);
};
var UpdateProductForm = function(props) {
    var job = props.job, submitState = props.submitState, onSubmit = props.onSubmit, onCancel = props.onCancel;
    var initialStatuses = flowFP([
        function(result) {
            return map(result, function(values, productKey) {
                return _object_spread({
                    productKey: productKey
                }, values);
            });
        },
        orderByFP([
            'createdAt'
        ], [
            'asc'
        ])
    ])(job === null || job === void 0 ? void 0 : job.detailed_status);
    var hasFormChanged = flowFP([
        pullAllWithFP(isEqual, initialStatuses),
        function(result) {
            return !isEmpty(result);
        }
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "UpdateProductForm"
    }, /*#__PURE__*/ React.createElement(Formik, {
        initialValues: {
            detailedStatus: initialStatuses,
            sendNotification: false
        },
        validateOnMount: true,
        validationSchema: updateFormSchema(hasFormChanged),
        enableReinitialize: true
    }, function(param) {
        var values = param.values, handleChange = param.handleChange, isValid = param.isValid, dirty = param.dirty;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldArray, {
            name: "detailedStatus"
        }, function(helpers) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UpdateProductTable, {
                initialProducts: initialStatuses,
                products: values.detailedStatus,
                productsHelpers: helpers
            }), /*#__PURE__*/ React.createElement("a", {
                href: "#",
                onClick: function(event) {
                    event.preventDefault();
                    helpers.push({
                        productKey: ''
                    });
                }
            }, "+ ".concat(text('addNewProduct'))));
        }), /*#__PURE__*/ React.createElement(Checkbox, {
            id: "sendNotification",
            onChange: handleChange,
            name: "sendNotification",
            value: values === null || values === void 0 ? void 0 : values.sendNotification,
            label: text('sendNotificationToCustomer')
        }), /*#__PURE__*/ React.createElement("div", {
            className: "form-footer"
        }, /*#__PURE__*/ React.createElement(Button, {
            loading: submitState.loading,
            disabled: !isValid || !dirty,
            onClick: function() {
                onSubmit(formatValues(initialStatuses, values.detailedStatus), values.sendNotification);
            }
        }, text('update')), /*#__PURE__*/ React.createElement("a", {
            name: "cancel",
            href: "#",
            onClick: onCancel
        }, text('cancel'))));
    }));
};
export default UpdateProductForm;
